export enum LoginStateFields {
  IS_ROOT = 'is_root',
  TENANT_NAME = 'tenant_name',
}
